import { ComponentType } from '../../registries/types/propTypes';
import type { FeaturedArticleCarousalComponentProps } from '../../../components/FeaturedArticleCarousalComponent/FeaturedArticleCarousalComponent';
import type { FeaturedArticleProps } from '../../../components/FeaturedArticle/types/propsTypes';
import { CMSTransformerDataType } from '../../types/common';
import { ImageDefination, type LinkDefination } from '../../../components/types/common';
import { ThemeShades } from '../../../utils/themeColor';
const transformfeaturedArticleCarousal = (data: CMSTransformerDataType): FeaturedArticleCarousalComponentProps => {
  const featuredArticleCarousal = Array.isArray(data?.featured_articles_carousal)
    ? data?.featured_articles_carousal[0]
    : data?.featured_articles_carousal;
  const featuredArticleCarousalTitle = featuredArticleCarousal.display_heading ?? '';
  const featuredArticleCarousalItems =
    featuredArticleCarousal.items?.map((featuredArticleCardCms: CMSTransformerDataType): FeaturedArticleProps => {
      const featuredArticleCard = Array.isArray(featuredArticleCardCms?.featured_article)
        ? featuredArticleCardCms.featured_article[0]
        : [];
      const images: ImageDefination[] = featuredArticleCard?.image?.images?.map((item: CMSTransformerDataType) => {
        const image = {
          url: item.image.url,
          altText: item.alt_text,
          viewport: item.viewport,
        };
        return image;
      });
      const brandTitle = featuredArticleCard.display_title ?? '';
      const cardTheme = featuredArticleCard.theme ?? 'theme-black';
      const themeColor = featuredArticleCard.theme_color?.color;
      const themeShade = ThemeShades.dark;
      const brandDescription = featuredArticleCard.description ?? '';
      const brandHeadLine = featuredArticleCard.headline ?? '';
      const brandReadTime = featuredArticleCard.read_time ?? '';
      const learnMore: LinkDefination = {
        text: featuredArticleCard.link?.text ?? '',
        url: featuredArticleCard.link?.url ?? '',
        target: featuredArticleCard.link?.target,
      };

      return {
        images,
        brandTitle,
        cardTheme,
        themeColor,
        themeShade,
        brandDescription,
        brandHeadLine,
        brandReadTime,
        learnMore,
      };
    }) || [];

  return {
    componentType: ComponentType.featured_articles_carousal,
    featuredArticleCarousalTitle: featuredArticleCarousalTitle,
    featuredArticleCarousalItems: featuredArticleCarousalItems,
  };
};

export default transformfeaturedArticleCarousal;
